import { Component, OnInit, OnDestroy, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';

@Component({
  selector: 'app-helpbutton-reports-ratings-card',
  templateUrl: './helpbutton-reports-ratings-card.component.html',
  styleUrls: ['./helpbutton-reports-ratings-card.component.scss']
})
export class HelpbuttonReportsRatingsCardComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() badCommentsNumber;
  @Input() neutralCommentsNumber;
  @Input() goodCommentsNumber;
  showCounter: boolean;
  badCount;
  neutralCount;
  goodCount;
  refreshAssistancesListSubscription: Subscription;

  constructor(private reportsService: ReportsHelpbuttonService,
              private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('reports-ratings-spinner');
    if ((null !== this.badCommentsNumber) && (undefined !== this.badCommentsNumber) && ('-' !== this.badCommentsNumber) &&
    (null !== this.neutralCommentsNumber) && (undefined !== this.neutralCommentsNumber) && ('-' !== this.neutralCommentsNumber) &&
    (null !== this.goodCommentsNumber) && (undefined !== this.goodCommentsNumber) && ('-' !== this.goodCommentsNumber)) {
      this.spinnerService.hide('reports-ratings-spinner');
      this.showCounter = true;
      this.badCount = this.badCommentsNumber;
      this.neutralCount = this.neutralCommentsNumber;
      this.goodCount = this.goodCommentsNumber;
    } else if (('-' === this.badCommentsNumber) && ('-' === this.neutralCommentsNumber) && ('-' === this.goodCommentsNumber)) {
      this.badCount = '-';
      this.neutralCount = '-';
      this.goodCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('reports-ratings-spinner');
    }
  }

  ngOnDestroy() {
    if (this.refreshAssistancesListSubscription) { this.refreshAssistancesListSubscription.unsubscribe(); }
  }
}
